import {Divider, Image, Carousel, Layout, Typography} from 'antd';
import React from 'react';
import appColors from '../../style/theme';

const {Text, Paragraph} = Typography;
const Content = Layout;
const UserManual = () => {
  return (
    <Layout style={{margin: '5.2vh', background: 'transparent'}}>
      <Content style={{background: 'inherit'}}>
        <Paragraph className= 'Title3' style={{color: appColors['ColorX'], marginTop: '-7vh'}}>User Manual</Paragraph>
        <Text className='BaseText2'>We decided to incorporate a <q>User Manua</q>l. This test could be used in the Health Centers where the test is applied in order to explain how to perform the test and to aid in the explanation of the results. We got inspired by the Taiwan iGEM Team CSMU from 2019 and decided to make our own user manual for our Lateral Flow Assay biosensor.</Text>
        <Content style={{marginLeft: '50%', transform: 'translateX(-50%)', marginTop: '2vh', width: '80vh', background: 'transparent'}}>
          <Carousel autoplay effect='fade' dotPosition='bottom' style={{marginLeft: '50%', transform: 'translateX(-50%)', width: '90vh'}}>
            <div>
              <Image src='https://static.igem.wiki/teams/4464/wiki/project-implementation/15.png'/>
            </div>
            <div>
              <Image src='https://static.igem.wiki/teams/4464/wiki/project-implementation/16.png'/>
            </div>
            <div>
              <Image src='https://static.igem.wiki/teams/4464/wiki/project-implementation/us17.png'/>
            </div>
          </Carousel>
          <p style={{textAlign: 'center'}}>User manual for our lateral flow assay biosensor. Created with BioRender.com.</p>
        </Content>
        <Text className='BaseText2' style={{marginTop: '-1%'}}>*This hasn’t been tested yet, but it was assumed as almost every lateral flow assay takes between 10-20 minutes to see the results [5].</Text>
        <Text className='BaseText2' style={{marginTop: '3%'}}>Taking into account that the imbalance between anti and proinflammatory responses is a key factor in the development of age-related diseases [6], we also designed an example of a <q>Results interpretation manual</q> for the rate of inflammatory risk using the ratio between a pro and anti inflammatory marker. </Text>
        <Content style={{marginLeft: 'auto', marginRight: 'auto', maxWidth: '80%', background: 'inherit', marginTop: '2%'}}>
          <Image src='https://static.igem.wiki/teams/4464/wiki/project-implementation/ratio-interpretation.png'/>
        </Content>
        <Text className='BaseText2' style={{marginTop: '3%'}}>Additionally, we believe that an app trained with artificial intelligence would be a helpful tool for the interpretation of the results. Therefore, we have designed a mock-up of how this would look like:</Text>
        <Content style={{marginLeft: 'auto', marginRight: 'auto', maxWidth: '80%', background: 'inherit', marginTop: '2%'}}>
          <Image src='https://static.igem.wiki/teams/4464/wiki/project-implementation/app.png'/>
        </Content>
      </Content>
      <Divider/>
    </Layout>
  );
};

export default UserManual;
